import React from "react";
import {
	AmountText,
	Modal,
} from "./CongratsModal.style";
import { useTranslation } from "react-i18next";
import { getFormattedNumber } from "@utils";
import moment from "moment";
import { ModalTopBg } from '@styles';
import { CongratsFilled, CoinFilled } from '@assets';

const CongratsModal = ({ data, handleOk }) => {
	const { t } = useTranslation();

	return (
		<>
			<Modal
				open={data.open}
				closable={false}
				centered={true}
				width={360}
				okText={t("common.ok")}
				title={t("spin.spinWinningTitle")}
				onOk={handleOk}
			>
				<ModalTopBg />
				<CongratsFilled id='modal-icon' />
				<div>{t("spin.spinWinningDescription")}</div>
				<AmountText>
					<CoinFilled />
					{`${getFormattedNumber(data.winningAmount ?? 0)}`}
				</AmountText>
				<div style={{ visibility: data.expired_on ? "visible" : "hidden", }}				>
					{t("spin.expiredMessage")}
					{` ${moment.unix(data.expired_on).format("D MMMM YYYY")}`}
				</div>
			</Modal>
		</>
	);
};

export default CongratsModal;
